import { DesktopView } from "../../View/AppView/DesktopView";
import { ViewController, AuthorityCodeChangeEvent, ModelUpdateEvent, TimeoutEvent, TimeUpdateEvent, MaintenanceEvent,
         ChannelSwitchEvent, DomInstantiateEvent, LocalStorageController } from "@gaming/srvg-classes-core";
import { VideoAreaViewController } from "./VideoAreaViewController";
import { ChunkIndicatorViewController } from "./ChunkIndicatorViewController";
import { ChunkAreaViewController } from "./ChunkAreaViewController";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";
import { ChunkRangeChangeEvent } from "../../Event/ChunkRangeChangeEvent";
import { CallToActionViewController, COUNTDOWN_START_PREMATCH } from "./CallToActionViewController";
import { GroupTablesGalleryViewController } from "./GroupTablesGalleryViewController";
import { ProgressbarViewController } from "./ProgressbarViewController";
import { ChunkModel } from "../../Model/ChunkModel";
import { MatchdayPickerLeagueViewController } from "./MatchdayPickerLeagueViewController";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";

export class DesktopViewController extends ViewController {
    desktopView:DesktopView;
    chunkPickerViewController:any; //MatchdayPickerLeagueViewController;
    videoAreaViewController:VideoAreaViewController;
    chunkIndicatorViewController:ChunkIndicatorViewController;
    chunkAreaViewController:ChunkAreaViewController;
    callToActionViewController: CallToActionViewController;
    groupTablesGalleryViewController: GroupTablesGalleryViewController;
    progressbarViewController: ProgressbarViewController;
    selectedChunkModel: ChunkModel;

    constructor(options) {
        options = options || {};
        options.view = options.desktopView || null;
        super(options);

        this.desktopView = options.desktopView || null;

        /******************* initialize controllers ************************/

        var hasFlash = false;
        // check if flash is available
        try {
            hasFlash = Boolean(new ActiveXObject('ShockwaveFlash.ShockwaveFlash'));
        } catch(exception) {

            hasFlash = ('undefined' != typeof navigator.mimeTypes['application/x-shockwave-flash']);
        }

        // videoView container existing?
        if ( $( "#videoView" ).length ) {
            if(hasFlash || srvg.Player.getWorkingStreamType() === "hls" || srvg.isMobile)
            {
                // initialize
                this.videoAreaViewController = this.addChildViewController( new VideoAreaViewController( { videoAreaView: this.desktopView.videoAreaView } ) );
            }
            else {
                // set warning message
                $('#videoControlbar').hide();
                $('#buttonbarView').hide();
                $('#videoView').addClass('noFlash');
            }
        }

        var exch = srvg.eventExchange;

        exch.addEventHandler(app.timelineController, 'all', ChannelSwitchEvent);
        exch.addEventHandler(app.customerIntegrationController, 'all', ChannelSwitchEvent);


        this.chunkIndicatorViewController = this.addChildViewController(new ChunkIndicatorViewController({
            chunkIndicatorView: this.desktopView.chunkIndicatorView
        }));
        if (srvg && srvg.config && srvg.config.modeItaly === true) {
            app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, AuthorityCodeChangeEvent);
        }

        app.timelineController.addSubscriberForEvent(app.server, TimeUpdateEvent);
        app.timelineController.addSubscriberForEvent(srvg.maintenance, MaintenanceEvent);
        app.timelineController.addSubscriberForEvent(app.customerIntegrationController, PhaseChangeEvent);

        var useChunkModel = false;

        if (srvg.product.mode == "VFLM" || srvg.product.mode == "VFB") {
            // LEAGUE

            useChunkModel = true;

            // add matchday picker controller
            this.chunkPickerViewController = this.addChildViewController(new MatchdayPickerLeagueViewController({}));
            app.timelineController.addSubscriberForEvent(this.chunkPickerViewController, PhaseChangeEvent);

            /******************* connect components ************************/

        }else{
            useChunkModel = false;
        }

        app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, PhaseChangeEvent);

        this.chunkAreaViewController = this.addChildViewController(new ChunkAreaViewController({
            useChunkModel: useChunkModel,
            chunkAreaView: this.desktopView.chunkAreaView
        }));

        if (this.desktopView.chunkAreaView.chunkPickerView) {
            // FIXME move
            this.desktopView.chunkAreaView.selectedChunkModel.addSubscriberForEvent(
                app.customerIntegrationController,
                ModelUpdateEvent
            );
        }
        app.timelineController.addSubscriberForEvent(this.chunkAreaViewController, ChunkRangeChangeEvent);
        app.timelineController.addSubscriberForEvent(this, PhaseChangeEvent);
        app.timelineController.addSubscriberForEvent(app, PhaseChangeEvent);


        this.progressbarViewController  = new ProgressbarViewController({
            progressbarView: this.desktopView.findSubViewBySelector( '#progressbarView', true )
        });
        app.timelineController.addSubscriberForEvent( this.progressbarViewController, PhaseChangeEvent );

        // subscribe all necessary controller and other for inactivity
        if( app.inactivityController ) {
            app.inactivityController.addSubscriberForEvent(app.server, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkAreaViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.desktopView, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.chunkIndicatorViewController, TimeoutEvent);
            app.inactivityController.addSubscriberForEvent(this.videoAreaViewController, TimeoutEvent);
            if(srvg.product.mode == "VFLM" || srvg.product.mode == "VFB") {
                app.inactivityController.addSubscriberForEvent(this.chunkPickerViewController, TimeoutEvent);
            }
            app.inactivityController.addSubscriberForEvent(this.chunkAreaViewController, TimeoutEvent);
        }

        /******************* start components ************************/
        app.timelineController.startPolling();
        if( app.inactivityController ) {
            app.inactivityController.startWaiting();
        }
        if( srvg.debugView ) {
            srvg.debugView.registerEventHandlers();
        }

        app.customerIntegrationController.startCustomerActions();


    }

    handlePhaseChangeEvent( event: PhaseChangeEvent, provider ) {
        this.desktopView.$domNode.attr('data-phase-name', event.phase.name);
    }

    handleDomInstantiateEvent( event: DomInstantiateEvent, provider ) {
        if( this.desktopView.findSubViewBySelector( '#calltoactionView', true ) ) {
            this.callToActionViewController = this.addChildViewController( new CallToActionViewController( {
                callToActionView: this.desktopView.findSubViewBySelector( '#calltoactionView', true ),
                countdownStartMode: COUNTDOWN_START_PREMATCH
            }) );
            this.addSubscriberForEvent( this.callToActionViewController, ChunkChangeEvent );
            app.timelineController.addSubscriberForEvent( this.callToActionViewController, PhaseChangeEvent );
            app.timelineController.addSubscriberForEvent(this.callToActionViewController, AuthorityCodeChangeEvent);
        }

        if( this.desktopView.findSubViewBySelector('#groupTablesGalleryView', true ) ) {
            this.groupTablesGalleryViewController = this.addChildViewController( new GroupTablesGalleryViewController( {
                galleryView: this.desktopView.findSubViewBySelector('#groupTablesGalleryView', true)
            } ) );
        }

        if( this.desktopView.findSubViewBySelector( '#chunkIndicatorView', true ) ) {
            this.chunkIndicatorViewController = this.addChildViewController( new ChunkIndicatorViewController( {
                chunkIndicatorView: this.desktopView.findSubViewBySelector( '#chunkIndicatorView', true )
            }) );

            app.timelineController.addSubscriberForEvent(this.chunkIndicatorViewController, AuthorityCodeChangeEvent);
        }

        if( app.videoSourceController instanceof LocalStorageController ) {
            // Video views are initialized now, local storage can start
            this.log( 'Initializing Local Storage' );
        }
        else {
            this.log( 'Initializing Streaming Source' );
        }
        // Must be called after the video views have been created and connected to their video channels.
        app.videoSourceController.connect();


        this.chunkAreaViewController = this.addChildViewController(new ChunkAreaViewController({
            useChunkModel: true,
            chunkAreaView: this.desktopView.chunkAreaView
        }));
    }

    // stop/disable all functions except of widgets and inactivitybutton
    handleTimeoutEvent(event: TimeoutEvent, provider){
        setTimeout(function() {
            srvg.eventExchange.eventSubscriptions = [];
        }, 2000);
    }
}
